import React from 'react';
import { TRow } from 'shared/Table/Table.models';
import { tableIds } from 'shared/Table/constants';
import { EngagementType } from 'pages/InsideSales/model';
import { TableProvider } from 'shared/Table/TableContext';
import { MRT_ColumnDef as ColumnDef } from 'material-react-table';
import { columns } from 'pages/InsideSales/InsideSalesList/constants';
import { TableActiveRowContextProvider } from 'shared/Table/TableActiveRowContext';
import InsideSalesListTable from 'pages/InsideSales/InsideSalesList/InsideSalesListTable';
import getInsideSalesAction from 'core/actions/crm/InsideSales/GetInsideSalesList/actions';
import useInsideSalesListPermissions from 'pages/InsideSales/InsideSalesList/useInsideSalesListPermissions';

const InsideSalesList = () => {
  const {
    isAvailableEditSidebar,
    isAvailableCancelRequest,
    isAvailableRequestAccepted,
  } = useInsideSalesListPermissions();

  const isEnableEditing = isAvailableEditSidebar || isAvailableCancelRequest;

  const enableRowSelection = isAvailableRequestAccepted && (({ original }) => {
    const isAcceptedDatetime = original?.acceptedDatetime;
    const isCanceledEngagementType = original?.engagementType === EngagementType.CANCELED;

    return !isAcceptedDatetime && !isCanceledEngagementType;
  });

  return (
    <TableActiveRowContextProvider>
      <div className="inside-sales-list">
        <TableProvider
          id={tableIds.insideSales}
          enableEditing={isEnableEditing}
          getDataAction={getInsideSalesAction}
          columns={columns as ColumnDef<TRow>[]}
          enableRowSelection={enableRowSelection}
        >
          <InsideSalesListTable />
        </TableProvider>
      </div>
    </TableActiveRowContextProvider>
  );
};

export default InsideSalesList;
